import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Avatar,
    Button,
    Typography,
    colors
} from '@material-ui/core';

import {
    FieldError
} from '../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    TextField
} from 'formik-material-ui';

import { PageContext } from '../PageContext';

import LogoCDI from '../../../../images/logo_cdi.png'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    logo: {
        margin: theme.spacing(3),
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export const LoginForm = ({
    formRef,
    disabled,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const {
        state,
        resetErrors
    } = useContext(PageContext);

    const {
        errors
    } = state;

    const getInitialValues = () => {
        return {
            email: "",
            fiscalCode: "",
            bookingCode: ""
        };
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    return (
        <div className={clsx(classes.root, props.className)}>
            <Formik
                enableReinitialize
                initialValues={getInitialValues()}
                onSubmit={submitClickHandler}
                innerRef={formRef}>
                {(props) => {
                    const { values, isSubmitting, handleSubmit } = props;
                    return (
                        <div className={classes.paper}>
                            <img className={classes.logo} src={LogoCDI} alt="CDI Logo" />
                            <Typography component="h1" variant="h5">
                                Login
                            </Typography>
                            <Form noValidate autoComplete="off">
                                <Field
                                    name="email"
                                    margin="normal"
                                    required
                                    fullWidth
                                    type="text"
                                    variant="outlined"
                                    placeholder="La tua email"
                                    autoComplete="email"
                                    autoFocus
                                    component={TextField}
                                    disabled={disabled}
                                />
                                <FieldError name="email" errors={errors} />
                                <Field
                                    name="fiscalCode"
                                    margin="normal"
                                    required
                                    fullWidth
                                    type="text"
                                    variant="outlined"
                                    placeholder="Il tuo codice fiscale"
                                    component={TextField}
                                    disabled={disabled}
                                />
                                <FieldError name="fiscalCode" errors={errors} />
                                <Field
                                    name="bookingCode"
                                    margin="normal"
                                    required
                                    fullWidth
                                    type="text"
                                    variant="outlined"
                                    placeholder="Il tuo codice univoco"
                                    component={TextField}
                                    disabled={disabled}
                                />
                                <FieldError name="bookingCode" errors={errors} />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    disabled={disabled}>
                                    Accedi
                                </Button>
                            </Form>
                        </div>
                    );
                }}
            </Formik>
        </div>
    );
}